export default __webpack_public_path__ + "47d9fecc62ea56f7c086461a9cc168b5.svg";